import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonStyle } from '@constants/button/1.0';
import { MatFormField, MatPrefix, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { NgIf, NgFor, NgClass } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { ButtonComponent } from '../../button/1.0/button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'txp-item-view',
  templateUrl: './item-view.component.html',
  styleUrls: ['./item-view.component.scss'],
  standalone: true,
  imports: [
    MatFormField,
    MatPrefix,
    MatInput,
    FormsModule,
    NgIf,
    MatIconButton,
    MatSuffix,
    NgFor,
    NgClass,
    ButtonComponent,
    TranslateModule,
  ],
})
export class ItemViewComponent {
  @Input() filterLabel: string;
  @Input() filterText: string;
  @Input() itemList: any[];
  @Input() showActionButtons: boolean;
  @Input() selectedItem: any;
  @Input() highlightInstructions: string;

  @Output() filter = new EventEmitter<string>();
  @Output() selectItem = new EventEmitter<any>();
  @Output() new = new EventEmitter<void>();
  @Output() duplicate = new EventEmitter<void>();
  @Output() delete = new EventEmitter<void>();

  buttonStyle = ButtonStyle;

  // function to run on the list item to determine if the item should be highlighted
  @Input() showItemHighlightFn: (item: any) => boolean = () => false;

  onSelectItem(item: any) {
    this.selectItem.emit(item);
  }

  onFilter(text: string) {
    this.filter.emit(text);
  }

  handleNew() {
    this.new.emit();
  }

  handleDuplicate() {
    this.duplicate.emit();
  }

  handleDelete() {
    this.delete.emit();
  }
}
